const config = {
    // hostname: "http://192.168.1.81:3000/api",
    // hostname: "http://127.0.0.1:3000/api",
    // hostname: "http://172.20.0.226:3000/api"
    // hostname: "http://13.235.215.57:8081/api",
    // hostname: "http://3.111.45.150:8081/api", //demo
    // hostname: "https://app.egoalprime.com:4443/api", //v2 server — REVERT TO THIS BEFORE SHIPPING
    hostname: "https://tp7oaih7ng.execute-api.ap-south-1.amazonaws.com/prod/egoal/api",
    // hostname: "https://aldar.egoalprime.com/v2api/api", //aldar

   //hostname: "http://localhost:3000/api"
};
// };

export default config;
